export class FilterModalitySlotViewModel {
  ModalityIds: number[];
  OrgId: number;
  FromDate: string;
  ToDate: string;
}
